/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect, useState, KeyboardEvent } from 'react'
// import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import axios from 'axios'
import { getSales } from '../../services/Sales/getSales'
import { getCompaniesAll } from '../../services/Companies/getCompanies'
import { getClientsAll } from '../../services/ClientServices/getClientService'
import { getVendedoresAll } from '../../services/SalesPeople/getSalesPeople'
import { getProductAll } from '../../services/ProductService/getProducts'
import { UseFormatador } from '../../components/FormatadorCpfCnpj'
// import 'dayjs/locale/pt-br'
// eslint-disable-next-line import/order
// import dayjs from 'dayjs'

export const useSales = () => {
  const { formatarCPF } = UseFormatador()

  const [searchValue, setSearchValue] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [sales, setSales] = useState<GetSalesType>({} as GetSalesType)

  const [dateStart, setDateStart] = useState('')
  const [dateEnd, setDateEnd] = useState('')

  const [calendarFim, setCalendarFim] = useState('')
  const [calendarInicio, setCalendarInicio] = useState('')
  const [valueCompanieId, setValueCompanieId] = useState<number[]>([])
  const [valueClientId, setValueClientId] = useState<number[]>([])
  const [valueProductId, setValueProductId] = useState<number[]>([])
  const [valueSalesPeopleId, setValueSalesPeopleId] = useState<number[]>([])

  const [clients, setClients] = useState<GetClientsAll>([])
  const [produto, setProduto] = useState<GetProductAll>([])
  const [companies, setCompanies] = useState<GetCompanieAll>([])
  const [vendedores, setVendedores] = useState<GetCompanieAll>([])
  const arrayClientes = Array.isArray(clients)
  const arrayVendedores = Array.isArray(vendedores)
  const arrayProdutos = Array.isArray(produto)
  const arrayEmpresas = Array.isArray(companies)

  const [showCompanies, setShowCompanies] = useState(false)
  const [showProducts, setShowProducts] = useState(false)
  const [showSalesPeople, setShowSalesPeople] = useState(false)
  const [showClient, setShowClient] = useState(false)
  const [showDate, setShowDate] = useState(false)

  const [valueCompanie, setValueCompanie] = useState<string[]>([])

  const [valueClient, setValueClient] = useState<string[]>([])

  const [valueProduct, setValueProduct] = useState<string[]>([])

  const [valueSalesPeople, setValueSalesPeople] = useState<string[]>([])

  // Segmento do cliente e Categoria de material. O valor exibido ja e o valor enviado a API, entao
  // nao ha array de ids derivado — so selecionado (value*) x aplicado (*Filtrado).
  // As OPCOES desses dois filtros nao sao buscadas aqui de proposito: este hook e instanciado varias
  // vezes por tela (o proprio SelectCompanie o chama), e buscar o catalogo aqui multiplicaria as
  // requisicoes. Quem monta a tela (Sales.tsx) chama useFiltrosCatalogo uma unica vez.
  const [valueSegmento, setValueSegmento] = useState<string[]>([])
  const [segmentoFiltrado, setSegmentoFiltrado] = useState<string[]>([])
  const [valueCategoria, setValueCategoria] = useState<string[]>([])
  const [categoriaFiltrada, setCategoriaFiltrada] = useState<string[]>([])
  const [showSegmento, setShowSegmento] = useState(false)
  const [showCategoria, setShowCategoria] = useState(false)

  const valueCompanieString = valueCompanie.map(id => {
    const companieName = companies.find(name => name.nome === id)
    return companieName ? companieName.id : undefined
  })

  const valueClientString = valueClient.map(id => {
    const clientName = clients.find(name => name.nome === id)
    return clientName ? clientName.id : undefined
  })

  const valueProductString = valueProduct.map(id => {
    const productName = produto.find(name => name.nome === id)
    return productName ? productName.id : undefined
  })

  const valueSalesPeopleString = valueSalesPeople.map(id => {
    const salesPeopleName = vendedores.find(name => name.nome === id)
    return salesPeopleName ? salesPeopleName.id : undefined
  })

  const clientArray = valueClientString.filter(
    value => value !== undefined
  ) as number[]

  const companieArray = valueCompanieString.filter(
    value => value !== undefined
  ) as number[]

  const productArray = valueProductString.filter(
    value => value !== undefined
  ) as number[]

  const salesPeopleArray = valueSalesPeopleString.filter(
    value => value !== undefined
  ) as number[]

  const [selectedOptionsCompanie, setSelectedOptionsCompanie] = useState<
    string[]
  >([])
  const [selectedOptionsClient, setSelectedOptionsClient] = useState<string[]>(
    []
  )
  const [selectedOptionsProduct, setSelectedOptionsProduct] = useState<
    string[]
  >([])
  const [selectedOptionsSalesPeople, setSelectedOptionsSalesPeople] = useState<
    string[]
  >([])

  const fetchSales = async (cancel?: any) => {
    setIsLoading(true)
    const result = await getSales(
      cancel,
      valueClientId,
      valueCompanieId,
      valueProductId,
      valueSalesPeopleId,
      calendarFim,
      calendarInicio,
      searchValue,
      currentPage,
      segmentoFiltrado,
      categoriaFiltrada
    )

    setIsLoading(false)
    setSearchValue('')
    if ('message' in result) {
      if (result.message === 'cancelToken') {
        ;('')
      } else {
        toast.error(result.message)
      }
    } else {
      setSales(result)
    }
  }

  const fetchCompanies = async () => {
    setIsLoading(true)
    const result = await getCompaniesAll('')
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setCompanies(result)
    }
  }
  const fetchClientes = async () => {
    setIsLoading(true)
    const result = await getClientsAll('')
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setClients(result)
    }
  }

  const fetchVendedores = async () => {
    setIsLoading(true)
    const result = await getVendedoresAll('')
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setVendedores(result)
    }
  }

  const fetchProduto = async () => {
    setIsLoading(true)
    const result = await getProductAll('')
    setIsLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setProduto(result)
    }
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const source = axios.CancelToken.source()
      fetchSales(source)
      return () => {
        source.cancel('cancelToken')
      }
    }
  }
  // Abrir um filtro fecha os demais (os paineis sao absolutos e se sobrepoem). Com a entrada de
  // Segmento e Categoria viraram 7 paineis; a lista central evita repetir o "fecha todos" dentro de
  // cada handler, que era onde faltava atualizar quando um filtro novo era acrescentado.
  const fecharTodosOsFiltros = () => {
    setShowCompanies(false)
    setShowClient(false)
    setShowProducts(false)
    setShowSalesPeople(false)
    setShowDate(false)
    setShowSegmento(false)
    setShowCategoria(false)
  }

  const alternarFiltro = (aberto: boolean, abrir: (valor: boolean) => void) => {
    fecharTodosOsFiltros()
    abrir(!aberto)
  }

  const handleKeyClosed = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      fecharTodosOsFiltros()
    }
  }
  const handleReload = () => {
    window.location.reload()
  }

  const handleShowFilterCompanies = () =>
    alternarFiltro(showCompanies, setShowCompanies)

  const handleShowFilterClient = () => alternarFiltro(showClient, setShowClient)

  const handleShowFilterProducts = () =>
    alternarFiltro(showProducts, setShowProducts)

  const handleShowFilterSalesPeople = () =>
    alternarFiltro(showSalesPeople, setShowSalesPeople)

  const handleShowFilterDate = () => alternarFiltro(showDate, setShowDate)

  const handleShowFilterSegmento = () =>
    alternarFiltro(showSegmento, setShowSegmento)

  const handleShowFilterCategoria = () =>
    alternarFiltro(showCategoria, setShowCategoria)

  const aplicarSegmento = () => {
    setSegmentoFiltrado(valueSegmento)
    // Volta para a primeira pagina: manter a atual poderia cair fora do novo total.
    setCurrentPage(1)
    setShowSegmento(false)
  }

  const aplicarCategoria = () => {
    setCategoriaFiltrada(valueCategoria)
    setCurrentPage(1)
    setShowCategoria(false)
  }

  useEffect(() => {
    fetchClientes()
    fetchCompanies()
    fetchVendedores()
    fetchProduto()
  }, [])

  useEffect(() => {
    setSearchValue('')
    const source = axios.CancelToken.source()
    fetchSales(source)
    return () => {
      source.cancel('cancelToken')
    }
  }, [
    currentPage,
    valueCompanieId,
    valueClientId,
    valueProductId,
    valueSalesPeopleId,
    calendarFim,
    calendarInicio,
    JSON.stringify(segmentoFiltrado),
    JSON.stringify(categoriaFiltrada),
  ])

  useEffect(() => {
    setSelectedOptionsCompanie(valueCompanie)
    setSelectedOptionsClient(valueClient)
    setSelectedOptionsProduct(valueProduct)
    setSelectedOptionsSalesPeople(valueSalesPeople)
  }, [valueCompanie, valueClient, valueProduct, valueSalesPeople])

  return {
    searchValue,
    setSearchValue,

    currentPage,
    setCurrentPage,
    sales,
    fetchSales,
    isLoading,
    handleKeyDown,

    handleShowFilterCompanies,
    handleShowFilterClient,
    handleShowFilterProducts,
    handleShowFilterSalesPeople,
    handleShowFilterDate,
    handleShowFilterSegmento,
    handleShowFilterCategoria,

    showCompanies,
    showClient,
    showProducts,
    showSalesPeople,
    showDate,
    showSegmento,
    showCategoria,

    valueSegmento,
    setValueSegmento,
    valueCategoria,
    setValueCategoria,
    segmentoFiltrado,
    categoriaFiltrada,
    aplicarSegmento,
    aplicarCategoria,

    companies,
    clients,
    vendedores,
    produto,

    setCalendarFim,
    setCalendarInicio,

    setValueCompanieId,
    setValueClientId,
    setValueProductId,
    setValueSalesPeopleId,

    handleKeyClosed,
    arrayClientes,
    arrayVendedores,
    arrayProdutos,
    arrayEmpresas,

    selectedOptionsSalesPeople,
    selectedOptionsProduct,
    selectedOptionsClient,
    selectedOptionsCompanie,
    salesPeopleArray,
    productArray,
    companieArray,
    clientArray,
    setValueSalesPeople,
    setValueClient,
    setValueProduct,
    setValueCompanie,
    valueCompanie,
    valueClient,
    valueProduct,
    valueSalesPeople,

    formatarCPF,
    dateStart,
    setDateStart,
    dateEnd,
    setDateEnd,
    handleReload,
  }
}
